export const blockIconsUiactionsLoginNew = (
	<span className='material-symbols-outlined'>login</span>
);
